import React, { useEffect } from "react";
import { Select, MenuItem, FormControl, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultLanguageAction } from "../store/actions";
import LanguageIcon from '@mui/icons-material/Language';
import { IsDevice } from "utils";

export const SelectLanguage = ({ hidden = false, size = "medium" }) => {
  const { IsMobile } = IsDevice()
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.SetDefualtLanguage?.lang);
  const defaultEnv = sessionStorage.getItem("lang") || process.env.REACT_APP_LANGUAGE || "es";
  const defaultLang = hidden
  ? process.env.REACT_APP_LANGUAGE || "es"
  : lang
  ? lang
  : defaultEnv;

  const LANGUAGES = [
    { label: "English", code: "en", labelMobile: "Eng" },
    { label: "Español", code: "es", labelMobile: "Esp"  },
    // { label: "Português", code: "pt", labelMobile: "Port"  },
    // { label: "日本語", code: "ja" },
  ];

  useEffect(() => {
    dispatch(setDefaultLanguageAction(defaultLang));
    i18n.changeLanguage(/* lang || "es" */ defaultLang);
    sessionStorage.setItem("lang", lang);
  }, []);

  const onChangeLang = (e) => {
    const lang_code = e.target.value;
    dispatch(setDefaultLanguageAction(lang_code));
    i18n.changeLanguage(lang_code);
    sessionStorage.setItem("lang", lang_code);
  };

  if (hidden) return <div />;

  return (
    <FormControl fullWidth display={"flex"} flexDirection={"row"}>
      {/*<InputLabel id="demo-simple-select-label">{t('general_language')}</InputLabel>*/}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        // label={t('general_language')}
        value={i18n.language}
        onChange={onChangeLang}
        renderValue={(value) => (
          <Box sx={{ display: "flex", gap: 1 }}>
            <LanguageIcon />
            {IsMobile ? LANGUAGES.find((language) => language.code === value)?.labelMobile : LANGUAGES.find((language) => language.code === value)?.label}
          </Box>
        )}
        size={size}
        sx={{ ".MuiOutlinedInput-notchedOutline": { borderStyle: "none" } }}
      >
        {LANGUAGES.map(({ code, label }) => (
          <MenuItem value={code}>{label}</MenuItem>
        ))} 
      </Select>
    </FormControl>
  );
};
